module.exports = __webpack_public_path__ + "img/level_03_silver.51891fe3.svg";